import { Typography } from '@mui/material';
import { Divider, LimitedContent, List, ListItem } from '@otp/ui';
import {
  ResourcePage,
  SearchResultDto,
  SearchType,
} from 'src/graphql/generated/graphql';
import { TFunction } from 'i18next';

export const HighlightColumn = ({
  t,
  item,
}: {
  item: Partial<SearchResultDto>;
  t: TFunction;
}) => {
  switch (item.type) {
    case SearchType.Resource:
      const parsedData = JSON.parse(item.data as string) as ResourcePage & {
        highlight?: Record<string, string[]>;
      };
      return (
        <LimitedContent maxRows={6}>
          {Object.entries(parsedData.highlight || {}).map(([key, value]) => (
            <div key={key} className="mb-2">
              <Typography variant="subtitle1" className="mb-1 font-bold">
                {t(`common.search.columns.highlight-keys.resource.${key}`)}
              </Typography>
              <Divider />
              <List className="p-0">
                {value.map((highlight, index) => (
                  <ListItem key={index}>
                    <div dangerouslySetInnerHTML={{ __html: highlight }}></div>
                  </ListItem>
                ))}
              </List>
            </div>
          ))}
        </LimitedContent>
      );
    default:
      return item.id;
  }
};
